import React, { Component } from "react";
import NavBar from "../Componentes/NavBar";
import Tabs from "../Componentes/Tabs";
import "./registro.css";
import fire from "../config/Fire";
import firebase from "firebase";
import Button from "@material-ui/core/Button";
import SweetAlert from "sweetalert2-react";

class registro extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.signup = this.signup.bind(this);
    this.state = {
      email: "",
      password: "",
      permisos: null
    };
  }
  //realiza la consulta para saber si tiene permisos de maestro
  componentDidMount() {
    fire
      .database()
      .ref()
      .child(fire.auth().currentUser.uid)
      .on("value", snapshot => {
        this.setState({ permisos: snapshot.val().permisos });
      });
  }
  //cambia los valores de los inputs
  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }
  //realiza el registro y validación
  signup(e) {
    var validator = require("email-validator"); //para validar que sea un correo
    if (validator.validate(this.state.email)) {
      var passwordValidator = require("password-validator"); // para validar que sea una password válida
      // Create a schema
      var schema = new passwordValidator();

      // Add properties to it
      schema
        .is()
        .min(6) // Minimum length 8
        .is()
        .max(20) // Maximum length 100
        .has()
        .not()
        .spaces(); // Should not have spaces

      if (schema.validate(this.state.password)) {
        e.preventDefault();
        const config = {
          apiKey: "AIzaSyAqcceg6A_bSPUJhNBtlIa0fQ6SOSjONUc",
          authDomain: "eventos-yt-74d35.firebaseapp.com",
          databaseURL: "https://eventos-yt-74d35.firebaseio.com",
          projectId: "eventos-yt-74d35",
          storageBucket: "eventos-yt-74d35.appspot.com",
          messagingSenderId: "486394821768"
        };

        const fire2 = firebase.initializeApp(config, "Secondary");

        fire2
          .auth()
          .createUserWithEmailAndPassword(this.state.email, this.state.password)
          .then(function(firebaseUser) {
            fire
              .database()
              .ref()
              .child(fire2.auth().currentUser.uid)
              .set({ permisos: "admin" });
            //I don't know if the next statement is necessary
            fire2
              .auth()
              .signOut()
              .then(function() {
                firebase.app("Secondary").delete();
              });
          });
        this.setState({ email: "", password: "" });
        this.setState({
          show: true,
          titulo: "¡Enhorabuena!",
          contenido: "Nuevo administrador dado de alta",
          tipo: "success"
        });
      } else {
        this.setState({
          show: true,
          titulo: "Error",
          contenido:
            "Debes ingresar una contraseña válida de al menos 6 caracteres",
          tipo: "error"
        });
      }
    } else {
      this.setState({
        show: true,
        titulo: "Error",
        contenido: "Debes ingresar un correo válido",
        tipo: "error"
      });
    }
  }
  //realiza el render del contenido
  render() {
    return (
      <div>
        <NavBar />
        <Tabs />
        <div class="center-screen2">
          <div class="div22">
            {this.state.permisos === "maestro" ? (
              <form>
                <label for="fname">Correo</label>
                <input
                  value={this.state.email}
                  onChange={this.handleChange}
                  type="text"
                  name="email"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  placeholder="Correo"
                />
                <label for="lname">Contraseña</label>
                <input
                  value={this.state.password}
                  onChange={this.handleChange}
                  type="password"
                  name="password"
                  class="form-control"
                  id="exampleInputPassword1"
                  placeholder="Contraseña"
                />
                <br />
                <br />
                <div className="Registar">
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={this.signup}
                  >
                    Registrar nuevo administrador
                  </Button>
                </div>
              </form>
            ) : (
              <h3 className="SinPermisos">
                No tienes permisos maestro para registrar nuevos administradores
              </h3>
            )}
          </div>
          <SweetAlert
            show={this.state.show}
            title={this.state.titulo}
            text={this.state.contenido}
            type={this.state.tipo}
            confirmButtonColor="#3085d6"
            confirmButtonText={"Aceptar"}
            onConfirm={() => this.setState({ show: false })}
          />
        </div>
      </div>
    );
  }
}

export default registro;
